<div class="manage-collections-panel-menu">
  <div class="manage-collections-panel-header">
    <h3
      [id]="panelTitleId"
      translate="library-collections_manage-collections"
      class="manage-collections-panel-title">
    </h3>
  </div>
  <div class="manage-collections-panel-content">
    <div class="manage-collections-subheader">
      <div
        translate="library-collections_manage-collections-subtitle"
        class="manage-collections-subtitle">
      </div>
      <div
        translate="library-collections_manage-collections-visible"
        class="manage-collections-subtitle">
      </div>
    </div>
    <div
      cdkDropList
      class="collection-cards"
      role="list"
      (cdkDropListDropped)="drop($event)">
      @for (collection of copiedCollections; track collection; let i = $index) {
        <div
          #listItem
          cdkDrag
          tabindex="0"
          class="collection-card"
          role="listitem"
          [attr.aria-label]="'aria-ng-sortable_inform-reorderable-name' | translate: {name: collection.name}"
          accessibleDropList
          [count]="copiedCollections.length"
          [currentIndex]="i"
          [name]="collection.name"
          [itemId]="collection.id"
          (activeItemChange)="onActiveItemChange($event)"
          (cancelReorder)="onCancelReorder($event)"
          (finalizePosition)="onFinalizePosition()">
          <div class="collection-card-handle" cdkDragHandle>
            <i class="collection-card-drag-handle ficon-app-gripper-dots-vertical"></i>
          </div>
          <div class="collection-card-title">
            {{collection.name}}
          </div>
          @if (canEditCollection(collection)) {
            <button
              (click)="modifyCollection(collection)"
              type="button"
              class="btn btn-none edit-collection-btn"
              data-cy="edit-collection-btn"
              [attr.aria-label]="'library-collections_manage-collections-edit' | translate: {collection: collection.name}">
              <i class="ficon-app-edit"></i>
            </button>
          }
          @if (canDeleteCollection(collection)) {
            <button
              (click)="deleteCollection(collection)"
              type="button"
              class="btn btn-none remove-collection-btn"
              data-cy="delete-collection-btn"
              [attr.aria-label]="'library-collections_manage-collections-remove' | translate: {name: collection.name}">
              <i class="ficon-app-x"></i>
            </button>
          }
          @if (collection.type !== libraryTypes.MINE) {
            <mat-checkbox
              color="primary"
              class="visibility-check"
              id="visible-check-{{collection.id}}"
              [checked]="!findMyPermission(collection).is_hidden"
              (change)="toggleCollectionVisibility(findMyPermission(collection))"
              [attr.aria-label]="'library-collections_manage-collections-visibility' | translate: {collection: collection.name}">
            </mat-checkbox>
          }
        </div>
      }
    </div>
    <button
      type="button"
      (click)="modifyCollection()"
      class="link-btn add-btn add-collection-btn"
      data-cy="add-collection-btn"
      translate="library-collections_manage-collections-add">
    </button>
  </div>
  <footer class="manage-collections-panel-footer">
    <button
      type="button"
      class="tertiary-btn cancel-btn"
      (click)="cancel()"
      translate="common_cancel">
    </button>

    <button
      type="submit"
      class="primary-btn submit-btn"
      [disabled]="saving$ | async"
      (click)="saveCollectionPermissions()"
      translate>
      common_save-and-close
      @if (saving$ | async) {
        <i class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'feedback-session_controller-saving'| translate}}"></i>
      }
    </button>
  </footer>
</div>
